import React from 'react';
import { CopyButton as CBMantine, ActionIcon, Tooltip } from '@mantine/core';
import IconCopy from '../../icons/IconCopy';
import PropTypes from 'prop-types';
import IconCheck from '../../icons/IconCheck';
import styles from './styles.scoped.css';

function CopyButton({ value }) {
  return (
    <CBMantine timeout={2000} value={value}>
      {({ copied, copy }) => (
        <Tooltip label={copied ? 'Copied' : 'Copy'} position="right" withArrow>
          <ActionIcon color={copied ? 'teal' : 'gray'} onClick={copy}>
            {copied ? <IconCheck className={styles.iconCheck}/> : <IconCopy size="1rem" />}
          </ActionIcon>
        </Tooltip>
      )}
    </CBMantine>
  );
}
export default CopyButton;
CopyButton.propTypes = {
  value: PropTypes.string
};
